module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAACCAYAAACpDacGAAAAAXNSR0IArs4c6QAAABxJREFUCB1jZPjvaM/A8N+BgeaA8QATze1AsgAAnrEDg9H2nR0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/SG.png
// module id = 170
// module chunks = 1